import { useLightbox } from "@/components/Lightbox";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

const TITLES = { flower_care: "Flower Care", merchandise_ideas: "Merchandise Ideas" };

export default function StoreContent() {
  const openLightbox = useLightbox();
  const { key } = useParams();
  const navigate = useNavigate();
  const [deck, setDeck] = useState(undefined);

  useEffect(() => {
    api.decks().then((d) => setDeck(d.find((x) => x.key === key) || null)).catch(() => setDeck(null));
  }, [key]);

  return (
    <div className="animate-fade-up" data-testid={`store-content-${key}`}>
      <button onClick={() => navigate("/store")} data-testid="content-back-home" className="mb-3 flex items-center gap-1 text-sm text-[#EBBAD1]"><ArrowLeft className="h-4 w-4" /> Back to home</button>
      {deck === undefined ? (
        <p className="py-16 text-center text-sm text-white/82">Loading…</p>
      ) : deck === null ? (
        <p className="py-16 text-center text-sm text-white/82">This content isn't available.</p>
      ) : (
        <>
          <div className="relative overflow-hidden rounded-3xl">
            {deck.image_url ? <img data-testid="content-deck-image" src={deck.image_url} alt={deck.title} onClick={() => openLightbox([deck.image_url])} className="h-48 w-full cursor-zoom-in object-cover" /> : <div className="h-48 w-full bg-white/10" />}
            <div className="absolute inset-0 bg-gradient-to-t from-[#28282E]/90 via-[#28282E]/50 to-transparent" />
            <div className="absolute inset-0 flex flex-col justify-end p-5">
              <div className="text-[11px] font-bold uppercase tracking-wide text-[#EBBAD1]">{deck.subtitle}</div>
              <h1 className="font-serif text-3xl font-extrabold">{deck.title || TITLES[key]}</h1>
            </div>
          </div>
          {deck.body ? <p className="mt-4 text-sm font-medium leading-relaxed text-white/90">{deck.body}</p> : null}
          <div className="mt-5 space-y-4">
            {(deck.sections || []).map((s, i) => (
              <div key={s.id || i} data-testid={`content-section-${i}`} className="overflow-hidden rounded-2xl bg-white/10">
                {s.image_url ? <img data-testid={`content-section-image-${s.id}`} src={s.image_url} alt={s.title} onClick={() => openLightbox([s.image_url])} className="h-44 w-full cursor-zoom-in object-cover" /> : null}
                <div className="p-4">
                  <div className="font-serif text-lg font-bold">{s.title}</div>
                  {s.body ? <p className="mt-1 text-sm font-medium leading-relaxed text-white/90">{s.body}</p> : null}
                </div>
              </div>
            ))}
            {(deck.sections || []).length === 0 && <p className="py-10 text-center text-sm text-white/82">No details yet.</p>}
          </div>
        </>
      )}
    </div>
  );
}
